// import React , {useNavigate} from 'react'
 
function Video() {
//    let navigate = useNavigate()
    // const videoRef = useRef(null)
    //  console.log(videoRef)

    //  const startVideo = () => {
    //     videoRef.current.play();
    //   };
    
    //   const handleVideoplay = () => {
    //     navigate("https://youtu.be/n0cQ9kTDg90") 
    //   };


  return (
    <div  >
        <img  width="100%" height="100%"
      src="https://logan.nnnow.com/content/dam/nnnow-project/18-aug-2022/ABH_Video_SS.jpg" />
       </div>
  )
}

export default Video